'use client';

import { useLayoutEffect } from 'react';

import { useAppRouter } from '@/hooks/use-app-router';

export default function Home() {
    const router = useAppRouter();

    useLayoutEffect(() => {
        router.replace('/discover');
    }, [router]);

    return null;
}
